import { atom } from 'recoil'

export default atom({
  key: 'step',
  default: 0,
})
